// src/lib/cookieConsent.js
const KEY = 'sohocard.cookie_consent';

export const CONSENT_ESSENTIAL = 'essential';
export const CONSENT_ALL = 'all';

export function getConsent() {
    try {
        return localStorage.getItem(KEY) || null;
    } catch {
        return null;
    }
}

export function setConsent(value) {
    try {
        localStorage.setItem(KEY, value);
        window.dispatchEvent(new CustomEvent('sohocard:consent', { detail: value }));
        return true;
    } catch {
        return false;
    }
}

export function clearConsent() {
    try {
        localStorage.removeItem(KEY);
        window.dispatchEvent(new CustomEvent('sohocard:consent', { detail: null }));
    } catch { }
}

export function hasAnalyticsConsent() {
    return getConsent() === CONSENT_ALL;
}